<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col-4">
        <PrivilegeTypesDropdown
          v-model="privilegeTypeSelected"
          @setPrivilegeType="setPrivilegeType"
        ></PrivilegeTypesDropdown>
      </div>
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailPrivilege' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getList"
          />
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listPrivileges"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(dateCreated)="data">
          <div>{{ setFormatDate(data.item.dateCreated) }}</div>
        </template>
        <template #cell(lastUpdated)="data">
          <div>{{ setFormatDate(data.item.lastUpdated) }}</div>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailPrivilege',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import PrivilegeService from "services/api/privilege.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import { PrivilegeStorageService } from "@/services/storage.service";
import DefaultListViewData from "@/views/defaultListViewData";
import fields from "./listPrivilegeFields.json";
import PrivilegeTypesDropdown from "components/Privilege/PrivilegeTypesDropdown";
import moment from "moment/moment";

export default {
  components: {
    PrivilegeTypesDropdown,
    BrandDropdown,
  },
  data() {
    return {
      ...DefaultListViewData,
      sort: { ...DefaultListViewData.sort },
      privilegeTypeSelected: null,
      listPrivileges: [],
      fields,
    };
  },
  mounted() {
    this.isLoading = true;
    this.brandSelected =
      JSON.parse(PrivilegeStorageService.getStoredBrand()) || {};
    let storedParams =
      JSON.parse(PrivilegeStorageService.getStoredParams()) || {};

    if (storedParams) {
      this.currentPage = storedParams.currentPage || 1;
      this.perPage = storedParams.limit || 10;
      this.sort.key = storedParams.sortColumn;
      this.sort.type = storedParams.sortType;
      this.searchText = storedParams.key;

      if (storedParams.privilegeTypeSelected != null) {
        this.privilegeTypeSelected = storedParams.privilegeTypeSelected;
      }
    }

    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brandCode: this.brandSelected?.id,
          privilegeType: this.privilegeTypeSelected?.id,
          privilegeTypeSelected: this.privilegeTypeSelected,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await PrivilegeStorageService.setStoredParams(param);
        delete param.privilegeTypeSelected;

        await PrivilegeService.getListPrivileges(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listPrivileges = data.privileges.map((p) => {
              return {
                ...p,
                privilegeType: this.capitalizeFirstLetterOnly(
                  p.privilegeType
                ).replace("_", " "),
                status: this.capitalizeFirstLetterOnly(p.status),
              };
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    capitalizeFirstLetterOnly(str) {
      return str.charAt(0) + str.slice(1).toLowerCase();
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      PrivilegeStorageService.setStoredBrand(this.brandSelected);
      this.getList(this.sort);
    },
    setPrivilegeType(privilegeType) {
      this.privilegeTypeSelected = privilegeType || "";
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      if (sortBy === "name") {
        sortBy = "nameEn";
      } else if (sortBy === "categoryName") {
        sortBy = "category";
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
    setFormatDate(value) {
      return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
